// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file file_service.proto (package cuda_learning, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { StaticImage, StaticVideo, TraceContext } from "./common_pb.js";

/**
 * @generated from message cuda_learning.ListAvailableImagesRequest
 */
export class ListAvailableImagesRequest extends Message<ListAvailableImagesRequest> {
  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 1 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<ListAvailableImagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ListAvailableImagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAvailableImagesRequest {
    return new ListAvailableImagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAvailableImagesRequest {
    return new ListAvailableImagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAvailableImagesRequest {
    return new ListAvailableImagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAvailableImagesRequest | PlainMessage<ListAvailableImagesRequest> | undefined, b: ListAvailableImagesRequest | PlainMessage<ListAvailableImagesRequest> | undefined): boolean {
    return proto3.util.equals(ListAvailableImagesRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.ListAvailableImagesResponse
 */
export class ListAvailableImagesResponse extends Message<ListAvailableImagesResponse> {
  /**
   * @generated from field: repeated cuda_learning.StaticImage images = 1;
   */
  images: StaticImage[] = [];

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 3 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<ListAvailableImagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ListAvailableImagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "images", kind: "message", T: StaticImage, repeated: true },
    { no: 3, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAvailableImagesResponse {
    return new ListAvailableImagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAvailableImagesResponse {
    return new ListAvailableImagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAvailableImagesResponse {
    return new ListAvailableImagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAvailableImagesResponse | PlainMessage<ListAvailableImagesResponse> | undefined, b: ListAvailableImagesResponse | PlainMessage<ListAvailableImagesResponse> | undefined): boolean {
    return proto3.util.equals(ListAvailableImagesResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.UploadImageRequest
 */
export class UploadImageRequest extends Message<UploadImageRequest> {
  /**
   * @generated from field: bytes file_data = 1 [json_name = "file_data"];
   */
  fileData = new Uint8Array(0);

  /**
   * @generated from field: string filename = 3;
   */
  filename = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<UploadImageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.UploadImageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_data", jsonName: "file_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadImageRequest {
    return new UploadImageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadImageRequest {
    return new UploadImageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadImageRequest {
    return new UploadImageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UploadImageRequest | PlainMessage<UploadImageRequest> | undefined, b: UploadImageRequest | PlainMessage<UploadImageRequest> | undefined): boolean {
    return proto3.util.equals(UploadImageRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.UploadImageResponse
 */
export class UploadImageResponse extends Message<UploadImageResponse> {
  /**
   * @generated from field: cuda_learning.StaticImage image = 1;
   */
  image?: StaticImage;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<UploadImageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.UploadImageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "image", kind: "message", T: StaticImage },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadImageResponse {
    return new UploadImageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadImageResponse {
    return new UploadImageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadImageResponse {
    return new UploadImageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UploadImageResponse | PlainMessage<UploadImageResponse> | undefined, b: UploadImageResponse | PlainMessage<UploadImageResponse> | undefined): boolean {
    return proto3.util.equals(UploadImageResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.ListAvailableVideosRequest
 */
export class ListAvailableVideosRequest extends Message<ListAvailableVideosRequest> {
  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 1 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<ListAvailableVideosRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ListAvailableVideosRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAvailableVideosRequest {
    return new ListAvailableVideosRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAvailableVideosRequest {
    return new ListAvailableVideosRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAvailableVideosRequest {
    return new ListAvailableVideosRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAvailableVideosRequest | PlainMessage<ListAvailableVideosRequest> | undefined, b: ListAvailableVideosRequest | PlainMessage<ListAvailableVideosRequest> | undefined): boolean {
    return proto3.util.equals(ListAvailableVideosRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.ListAvailableVideosResponse
 */
export class ListAvailableVideosResponse extends Message<ListAvailableVideosResponse> {
  /**
   * @generated from field: repeated cuda_learning.StaticVideo videos = 1;
   */
  videos: StaticVideo[] = [];

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 3 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<ListAvailableVideosResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ListAvailableVideosResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "videos", kind: "message", T: StaticVideo, repeated: true },
    { no: 3, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAvailableVideosResponse {
    return new ListAvailableVideosResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAvailableVideosResponse {
    return new ListAvailableVideosResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAvailableVideosResponse {
    return new ListAvailableVideosResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAvailableVideosResponse | PlainMessage<ListAvailableVideosResponse> | undefined, b: ListAvailableVideosResponse | PlainMessage<ListAvailableVideosResponse> | undefined): boolean {
    return proto3.util.equals(ListAvailableVideosResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.UploadVideoRequest
 */
export class UploadVideoRequest extends Message<UploadVideoRequest> {
  /**
   * @generated from field: bytes file_data = 1 [json_name = "file_data"];
   */
  fileData = new Uint8Array(0);

  /**
   * @generated from field: string filename = 3;
   */
  filename = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<UploadVideoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.UploadVideoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_data", jsonName: "file_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadVideoRequest {
    return new UploadVideoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadVideoRequest {
    return new UploadVideoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadVideoRequest {
    return new UploadVideoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UploadVideoRequest | PlainMessage<UploadVideoRequest> | undefined, b: UploadVideoRequest | PlainMessage<UploadVideoRequest> | undefined): boolean {
    return proto3.util.equals(UploadVideoRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.UploadVideoResponse
 */
export class UploadVideoResponse extends Message<UploadVideoResponse> {
  /**
   * @generated from field: cuda_learning.StaticVideo video = 1;
   */
  video?: StaticVideo;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<UploadVideoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.UploadVideoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "video", kind: "message", T: StaticVideo },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadVideoResponse {
    return new UploadVideoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadVideoResponse {
    return new UploadVideoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadVideoResponse {
    return new UploadVideoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UploadVideoResponse | PlainMessage<UploadVideoResponse> | undefined, b: UploadVideoResponse | PlainMessage<UploadVideoResponse> | undefined): boolean {
    return proto3.util.equals(UploadVideoResponse, a, b);
  }
}

